export default "__VITE_ASSET__BwJ$fHej__"